import React from 'react';
import styled from 'styled-components';
import ProjectsSection from '../components/sections/ProjectsSection';

const ProjectsPage = () => {
  return (
    <ProjectsPageContainer>
      <ProjectsSection />
    </ProjectsPageContainer>
  );
};

const ProjectsPageContainer = styled.div`
  padding-top: 2rem;
`;

export default ProjectsPage;